import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';

import slide_image_1 from '../../assets/mainservicesimage/web.jpg';
import slide_image_2 from '../../assets/dsigniibgimage/img3.jpeg';
import slide_image_3 from '../../assets/mainservicesimage/logoimage.jpg';
import slide_image_4 from '../../assets/mainservicesimage/seoimage.jpg';
import slide_image_5 from '../../assets/mainservicesimage/E-INIVITATION.jpg';
import slide_image_6 from '../../assets/mainservicesimage/brandingimage.jpg';
import slide_image_7 from '../../assets/mainservicesimage/socialmediaimage.jpg';

import "./service.css";
import { IoArrowBackOutline, IoArrowForwardOutline } from 'react-icons/io5';
import Navbar from '../navbar/Navbar';
import { Link } from 'react-router-dom';

function Servicepage1() {
  
  // Change HTML font size only on this page
  useEffect(() => {
    document.documentElement.style.fontSize = "62.5%"; // 1rem = 10px
    return () => {
      document.documentElement.style.fontSize = ""; // reset when leaving
    };
  }, []);

  return (
    <>
     

      <Navbar />
      <section className='section-margin'>
        <center>
          <div className='heading-for-all'>
            <h2 className='services-heading-h2'>Our services</h2>
          </div>
        </center>
      </section>
      <div className="slider-page">
        <div className="container mainnn-con">

          <Swiper
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            loop={true}
            slidesPerView={'auto'}
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 100,
              modifier: 2.5,
            }}
            pagination={{ el: '.swiper-pagination', clickable: true }}
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
              clickable: true,
            }}
            modules={[EffectCoverflow, Pagination, Navigation]}
            className="swiper_container"
          >
           <SwiperSlide>
  <Link to="/web">
    <img src={slide_image_1} alt="slide_image" />
    <div className="slide-overlay">Web Development</div>
  </Link>
</SwiperSlide>

<SwiperSlide>
  <Link to="/logo">
    <img src={slide_image_3} alt="slide_image" />
    <div className="slide-overlay">Logo Design</div>
  </Link>
</SwiperSlide>

<SwiperSlide>
  <Link to="/Invitation">
    <img src={slide_image_5} alt="slide_image" />
    <div className="slide-overlay">E-Invitation</div>
  </Link>
</SwiperSlide>

<SwiperSlide>
  <Link to="/seo">
    <img src={slide_image_4} alt="slide_image" />
    <div className="slide-overlay">SEO Services</div>
  </Link>
</SwiperSlide>

<SwiperSlide>
  <Link to="/branding">
    <img src={slide_image_6} alt="slide_image" />
    <div className="slide-overlay">Branding</div>
  </Link>
</SwiperSlide>

<SwiperSlide>
  <Link to="/socialmedia">
    <img src={slide_image_7} alt="slide_image" />
    <div className="slide-overlay">Social Media</div>
  </Link>
</SwiperSlide>

<SwiperSlide>
  <Link to="/digital">
    <img src={slide_image_2} alt="slide_image" />
    <div className="slide-overlay">Digital Marketing</div>
  </Link>
</SwiperSlide>

            {/* Custom navigation */}
            <div className="slider-controler">
              <div className="swiper-button-prev slider-arrow">
                <IoArrowBackOutline size={20} color="white" />
              </div>
              <div className="swiper-button-next slider-arrow">
                <IoArrowForwardOutline size={20} color="white" />
              </div>
              <div className="swiper-pagination"></div>
            </div>
          </Swiper>

        </div>
      </div>
    
    </>
  );
}

export default Servicepage1;
